import { tr } from './i18n';

/**
 * Ce que chaque sorte de signal montre dans la cloche : une icône, un libellé
 * traduit, et l'onglet de l'espace employé qu'il ouvre.
 */
const SORTES = {
  MESSAGE: { icone: '💬', libelle: 'Message du bureau', onglet: 'communication' },
  CONSIGNE: { icone: '📋', libelle: 'Consigne', onglet: 'communication' },
  RDV: { icone: '📅', libelle: 'Nouveau rendez-vous', onglet: 'rdv' },
  RDV_MODIFIE: { icone: '🔁', libelle: 'Rendez-vous déplacé', onglet: 'rdv' },
  RDV_ANNULE: { icone: '❌', libelle: 'Rendez-vous annulé', onglet: 'rdv' },
  RDV_RAPPEL: { icone: '⏰', libelle: 'Rappel : rendez-vous demain', onglet: 'rdv' },
  PLAN: { icone: '📐', libelle: 'Nouveau plan', onglet: 'plans' },
  PLANNING: { icone: '🗓', libelle: 'Ton planning a changé', onglet: 'rdv' },
  CHANTIER_DU_JOUR: { icone: '🏗', libelle: 'Ton chantier du jour', onglet: 'rdv' },
  DOCUMENT: { icone: '📄', libelle: 'Nouveau document', onglet: 'documents' },
  FICHE_DE_PAIE: { icone: '💰', libelle: 'Nouvelle fiche de paie', onglet: 'salaire' },
  CONGE: { icone: '🌴', libelle: 'Réponse à ton congé', onglet: 'vacances' },
  FORMATION: { icone: '🎓', libelle: 'Formation', onglet: 'formation' },
};

/**
 * @param {string} type sorte du signal
 * @returns {{icone: string, libelle: string, onglet: string}} sa présentation
 */
export function sorteDuSignal(type) {
  return SORTES[type] || { icone: '🔔', libelle: 'Nouveau', onglet: null };
}

/**
 * Le titre lisible d'un signal, dans la langue de l'écran. Le serveur écrit
 * le sien en français ; l'écran traduit ce qu'il connaît.
 *
 * @param {object} s signal
 * @returns {string} le titre
 */
export function titreDuSignal(s) {
  if (!s) return '';
  return tr(s.titre || sorteDuSignal(s.type).libelle);
}

/** @param {object} s signal @returns {boolean} vrai pour une convocation à laquelle on répond */
export function estUnRendezVous(s) {
  return !!s && (s.type === 'RDV' || s.type === 'RDV_MODIFIE' || s.type === 'RDV_RAPPEL');
}

/**
 * Où mène un signal dans l'espace de l'employé.
 *
 * @param {object} s signal
 * @param {{estMagOuv?: boolean}} [contexte] l'employé d'un magasin n'a ni plans ni chantiers
 * @returns {{onglet: ?string, chantierId: ?number, fichier: boolean}} la destination
 */
export function ongletDuSignal(s, contexte = {}) {
  if (!s) return { onglet: null, chantierId: null, fichier: false };
  const sorte = sorteDuSignal(s.type);
  if (s.type === 'PLAN') {
    // Un plan sans chantier (lieu tapé à la main) s'ouvre tel quel ; au
    // magasin il n'y a pas d'onglet Plans.
    if (s.nomFichier && (!s.siteId || contexte.estMagOuv)) {
      return { onglet: null, chantierId: null, fichier: true };
    }
    return {
      onglet: contexte.estMagOuv ? 'documents' : 'plans',
      chantierId: s.siteId ?? null,
      fichier: false,
    };
  }
  if (s.type === 'DOCUMENT' && s.nomFichier) {
    return { onglet: 'documents', chantierId: null, fichier: true };
  }
  return { onglet: sorte.onglet, chantierId: s.siteId ?? null, fichier: false };
}
